import React from 'react';
import PropTypes from 'prop-types';
import QRCode from 'react-qr-code';
import Spinner from 'react-spinner-material';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Notifications } from 'ipapps-corejs';
import styles from './styles';
import {
  QRVALUE_ACTION_TYPES,
  VEHICLE_CAPABLE_ACTION,
  FORGEROCK_ACTION_TYPES,
  SUBSCRIPTION_ACTION,
  REMOTE_STATUS_ACTION,
} from '../../redux-saga/actionTypes/index';
import VehicleCapability from '../VehicleCapablity/VehicleCapability';
import AuthenticationInfo from '../AuthenticationInfo/AuthenticationInfo';
import SubscriptionError from '../SubscriptionError/SubscriptionError';
import { TestNativeFeatures } from '../TestNativeFeatures';

export class AppQRCode extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount = () => {
    this.props.getQrAuthValue();
    setTimeout(() => {
      this.setState({ loading: false });
    }, 2000);
  }

  componentDidUpdate = () => {
    const { auth, remoteStatus, error, subscription_error } = this.props;
    const showQRCode = !subscription_error && !error;

    if (showQRCode && remoteStatus && auth) {
      this.renderShowAuthStatus();
    }

  }

  renderShowAuthStatus = () => {
    const notification = new Notifications();
    const options = {
      body: [
        {
          en: 'Vehicle linking is complete',
          es: 'El enlace del vehículo está completo',
          fr: 'La liaison de véhicule est terminée',
        },
      ],
      icon: '@icon.navigation.CheckCircle.primary1',
      icon_bg: '@fillPrimary1',
    };
    notification.native(options);
  };
  /**
   * @name render
   * @description react component render
   */
  render() {
    const { classes, qrValue, error, subscription_error, auth, remoteStatus } = this.props;
    const showTestSettings = window.location.href.indexOf('testsettings=true') > 0;

    const showQRCode = !subscription_error && !error;

    const code =
      qrValue && qrValue.user_code
        ? `${qrValue.verification_url}?user_code=${qrValue.user_code}`
        : '';

    return this.state.loading ? (
      <div className={classes.loading}>
        <Spinner size={120} spinnerColor="black" visible />
      </div>
    ) : (
      <React.Fragment>
        {!auth && qrValue && showQRCode && !remoteStatus && (
          <div className={classes.container}>
            {this.renderWelcomeMessage()}
            {this.renderContents(code)}
          </div>
        )}
        {showQRCode && remoteStatus && auth && <AuthenticationInfo />}
        {subscription_error && <SubscriptionError />}
        {error && <VehicleCapability />}
        {showTestSettings && <TestNativeFeatures />}
      </React.Fragment>
    );
  }

  /**
   *
   */
  renderContents = code => {
    const { classes, t } = this.props;
    return (
      <div className={classes.contents}>
        <div>
          <div className={classes.QRimage}>
            <QRCode value={code} bgColor="transparent" />
          </div>
          <div className={classes.actions}>
            <span className={classes.QR_auth_loginByQRCode}>{t('welcome.loginByQRCode')}</span>
          </div>
        </div>
      </div>
    );
  };

  /**
   * @name
   */
  renderWelcomeMessage = () => {
    const { classes, t } = this.props;
    return (
      <div className={classes.title}>
        <div className={classes.titleCenter}>
          <div className={classes.QR_auth_heading}>{t('welcome.toyotaqrauth')}</div>
          <div className={classes.QR_auth_instruction}>
            <div className={classes.auth_instr}>{t('welcome.instruction')}</div>
          </div>
        </div>
      </div>
    );
  };

}

AppQRCode.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  getQrAuthValue: PropTypes.func.isRequired,
  qrValue: PropTypes.object,
  error: PropTypes.string,
  subscription_error: PropTypes.string,
  auth: PropTypes.string,
  remoteStatus: PropTypes.bool,
};

AppQRCode.defaultProps = {
  qrValue: {},
  error: '',
  subscription_error: '',
  auth: '',
  remoteStatus: false,
};

const mapStateToProps = state => ({
  qrValue: state.qrValue.qrValue,
  error: state.vehicleCapable.error,
  subscription_error: state.subscription.error,
  auth: state.forgerock.forgerock_Value,
  remoteStatus: state.remoteStatus.remoteStatus,
});

const mapDispatchToProps = dispatch => ({
  getVehicleCapable: () => dispatch({ type: VEHICLE_CAPABLE_ACTION.IS_VEHICLE_CAPABLE }),
  vehicleCapableError: () =>
    dispatch({ type: VEHICLE_CAPABLE_ACTION.VEHICLE_CAPABLE_ERROR, payload: 'error' }),
  subscriptionError: () =>
    dispatch({ type: SUBSCRIPTION_ACTION.SUBSCRIPTION_ERROR, payload: 'error' }),
  getQrAuthValue: () => dispatch({ type: QRVALUE_ACTION_TYPES.POST.IN_PROGRESS }),
  updateAuthStatus: () => dispatch({ type: REMOTE_STATUS_ACTION.IS_REMOTE_SUBSCRIPTION, payload: 'completed' }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(AppQRCode)),
);
